import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'sigv-fixed-bottom-panel',
  templateUrl: './fixed-bottom-panel.component.html',
  styleUrls: ['./fixed-bottom-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FixedBottomPanelComponent implements OnInit, OnDestroy {
  scrollListener: any;
  visible = false;
  reachBottom = false;
  constructor(public el: ElementRef, private cd: ChangeDetectorRef) {}

  @Input() styleClass = '';
  @Input() showTransitionOptions = '.15s';
  @Input() hideTransitionOptions = '.15s';
  @Input() threshold = 400;

  @HostListener('window:scroll', ['$event']) onScroll(event: any): void {
    const currentOffset = document.documentElement.scrollTop + document.documentElement.offsetHeight;
    const endOffset = document.documentElement.scrollHeight;
    this.reachBottom = currentOffset === endOffset;
}

  get getFooterHeight(): number{
    return this.reachBottom ? document.getElementsByTagName('footer')[0]?.clientHeight ?? 0 : 0;
  }
  ngOnInit(): void {
    this.bindDocumentScrollListener();
  }

  ngOnDestroy(): void {
    this.unbindDocumentScrollListener();
  }

  checkVisibility(scrollY: number): void {
    if (scrollY > this.threshold) {
      this.visible = true;
    } else {
      this.visible = false;
    }

    this.cd.markForCheck();
  }

  bindDocumentScrollListener(): void {
    this.scrollListener = () => {
      this.checkVisibility(this.getWindowScrollTop());
    };

    window.addEventListener('scroll', this.scrollListener);
  }

  unbindDocumentScrollListener(): void {
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
      this.scrollListener = null;
    }
  }

  getWindowScrollTop(): number {
    const doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  }
}
